var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0575 12.3005C11.6041 11.6577 12.6998 10.095 12.6998 8.26127C12.6998 5.85532 10.8191 3.90442 8.4998 3.90442C6.18047 3.90442 4.2998 5.85532 4.2998 8.26127C4.2998 10.095 5.39554 11.6577 6.94207 12.3005",
    stroke: "#797B80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0984 15C13.6763 13.9292 15.5 11.318 15.5 8.26141C15.5 4.25118 12.3659 1 8.5 1C4.63413 1 1.5 4.25118 1.5 8.26141C1.5 11.318 3.32373 13.9292 5.9016 15",
    stroke: "#797B80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49961 9.71377C9.27281 9.71377 9.89961 9.06356 9.89961 8.26149C9.89961 7.45941 9.27281 6.8092 8.49961 6.8092C7.72641 6.8092 7.09961 7.45941 7.09961 8.26149C7.09961 9.06356 7.72641 9.71377 8.49961 9.71377Z",
    stroke: "#797B80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkLogo);
export default __webpack_public_path__ + "static/media/networkLogo.1be4ea9bfb4afe45766781e7cd024fee.svg";
export { ForwardRef as ReactComponent };